import { SquareArrowOutUpRight } from "lucide-react";
import React from "react";

import {
  IgBadge,
  IgButton,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { StepCardsContainerProps } from "./types";

export const StepCardsContainer = ({ steps }: StepCardsContainerProps) => {
  const theme = useTheme();
  return (
    <Grid container direction={"column"} rowSpacing={2}>
      {steps.map((step, index) => (
        <Grid key={index}>
          <IgPaper
            sx={{
              padding: "0",
              height: "100px",
              overflow: "hidden",
            }}
          >
            <Grid
              container
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              wrap={"nowrap"}
              sx={{
                paddingLeft: 4,
                paddingTop: step?.image ? 0 : 4,
                paddingRight: step?.image ? 0 : 4,
                paddingBottom: step?.image ? 0 : 4,
                height: "100%",
              }}
            >
              <Grid
                container
                direction={"row"}
                wrap={"nowrap"}
                alignItems={"center"}
                columnSpacing={3}
                sx={{
                  paddingTop: !step?.image ? 0 : 4,
                  paddingRight: !step?.image ? 0 : 4,
                  paddingBottom: !step?.image ? 0 : 4,
                }}
              >
                <Grid ml={4} mr={4}>
                  <IgBadge badgeContent={index + 1} color={"accent"} />
                </Grid>
                <Grid>
                  <Stack
                    // spacing={2}
                    direction={"column"}
                    sx={{
                      maxWidth: step?.image ? "309px" : "378px",
                      width: step?.image ? "309px" : "378px",
                      overflow: "visible",
                    }}
                  >
                    <IgTypography
                      variant={"body1"}
                      fontWeight={600}
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      {step.title}
                    </IgTypography>

                    <IgTypography
                      variant={"body2"}
                      color={theme.palette.text.secondary}
                    >
                      {step.description}
                    </IgTypography>
                  </Stack>
                </Grid>
              </Grid>
              {step.button ? (
                <IgButton
                  onClick={step.button.onButtonClick}
                  startIcon={step.button.startIcon}
                  disabled={step.button.disabled}
                  variant={step.button.variant}
                  endIcon={
                    step.button.endIcon !== undefined ? (
                      step.button.endIcon
                    ) : step.button.text.includes("Open") ? (
                      <SquareArrowOutUpRight
                        size={16}
                        color={theme.palette.common.white}
                      />
                    ) : undefined
                  }
                  sx={{
                    whiteSpace: "nowrap",
                    minWidth: "fit-content",
                  }}
                  color={step.button.color || "secondary"}
                >
                  {step.button.text}
                </IgButton>
              ) : (
                <Box
                  sx={{
                    height: "100%",
                  }}
                >
                  {step.image}
                </Box>
              )}
            </Grid>
          </IgPaper>
        </Grid>
      ))}
    </Grid>
  );
};
